import React, { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { checkAuth } from "../libs/auth";
import { setUser, setUserToken } from "../libs/user";
import { getUserProfile } from "../services/auth";
import FullScreenSkeleton from "./Skeletons/FullScreenSkeleton";

const Protected = ({ children }) => {
  window.console.time("Protected:Start");
  const [searchParams] = useSearchParams();
  const extToken = searchParams.get("token");
  let channel = searchParams.get("channel") || "";
  const theme = searchParams.get("theme") || "";

  const [TOIChannelData, setTOIChannelData] = useState(false);

  console.log("URL", window.location.href);
  console.log("channel", channel);
  console.log("theme", theme);

  if (extToken) {
    setUserToken(extToken);
    getUserProfile(extToken)
      .then((response) => {
        setUser(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  if (channel) {
    window.sessionStorage.setItem("channel", channel);
  }
  if (theme) {
    window.sessionStorage.setItem("theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  }

  useEffect(() => {
    if (channel === "TOI") {
      if (
        typeof window.webkit?.messageHandlers?.tilAppWebBridge !== "undefined"
      ) {
        window.webkit.messageHandlers.tilAppWebBridge.postMessage({
          requestReason: "fetchAppData",
          type: "abound",
          value: "",
        });
      }
      if (typeof window.tilAppWebBridge !== "undefined") {
        window.tilAppWebBridge.postMessage(
          JSON.stringify({
            requestReason: "fetchAppData",
            type: "abound",
            value: "",
          })
        );
      }
    }
  }, [channel]);

  window.messageFromApp = (data) => {
    window.console.timeEnd("Protected:End");
    console.log("messageFromApp", data);
    let storedUserData =
      typeof data === "string" ? JSON.parse(data).response : data.response;
    if (typeof storedUserData === "string") {
      storedUserData = storedUserData.replace(/^'|'$/g, "");
      storedUserData = JSON.parse(storedUserData);
    }
    console.log("storedUserData", storedUserData);
    window.sessionStorage.setItem("theme", storedUserData.appTheme || "light");
    window.sessionStorage.setItem("channel", storedUserData.channel);
    document.documentElement.setAttribute(
      "data-theme",
      storedUserData.appTheme
    );
    if (typeof storedUserData.email != "undefined" && storedUserData.email) {
      window.sessionStorage.setItem("email", storedUserData.email);
    }
    if (storedUserData.token) {
      setUserToken(storedUserData.token);
    }
    setTOIChannelData(true);
  };

  if (channel === "TOI" && !TOIChannelData) {
    return <FullScreenSkeleton />;
  }
  const isLoggedIn = checkAuth();
  console.log("/toi/landing: isLoggedIn", isLoggedIn, channel, TOIChannelData);
  if (!isLoggedIn && channel === "TOI") {
    return <Navigate to="/toi/landing" replace />;
  }
  if (!isLoggedIn) {
    return <Navigate to="/login?type=mobile" replace />;
  }
  return children;
};

export default Protected;
